import { render, staticRenderFns } from "./PassportLayout.vue?vue&type=template&id=5335ae08&"
import script from "./PassportLayout.vue?vue&type=script&lang=js&"
export * from "./PassportLayout.vue?vue&type=script&lang=js&"
import style0 from "./PassportLayout.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports